import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import numeral from 'numeral';
import { Colors } from '../constants';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  height: 40px;
  margin-bottom: 2px;
  background: ${props => props.theme.fav.rowBg};
  &:last-child {
    margin-bottom: 0;
  }
`;

const Rank = styled.div`
  width: 40px;
  color: ${props => props.theme.fav.title};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Symbol = styled.div`
  flex: 3;
  color: ${props => props.theme.fav.title};
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const Price = styled.div`
  flex: 3;
  color: ${props => props.theme.fav.title};
  font-size: 20px;
  display: flex;
  align-items: center;
`;

const Diff = styled.span`
  flex: 1;
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const PFRow = ({
  theme,
  coin: {
    id,
    name,
    symbol,
    rank,
    priceUsd,
    priceBtc,
    volumeUsd24,
    marketCapUsd,
    availableSupply,
    totalSupply,
    maxSupply,
    percentChange1h,
    percentChange24h,
    percentChange7d,
    lastUpdated,
  },
}) => {
  const priceUSDFmt = numeral(priceUsd).format('$0,0.00');
  const percFmt = +percentChange1h >= 0 ? `+${percentChange1h}` : percentChange1h;
  return (
    <ThemeProvider theme={theme}>
      <Row>
        <Rank>{rank}</Rank>
        <Symbol>{symbol}</Symbol>
        <Price>{priceUSDFmt}</Price>
        <Diff value={+percentChange1h}>{percFmt}%</Diff>
      </Row>
    </ThemeProvider>
  );
};

export default withTheme(PFRow);



// WEBPACK FOOTER //
// ./src/components/MCRow.js